"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highlight;

var _core = _interopRequireDefault(require("refractor/core"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const aliases = {
  js: 'jsx'
};

_core.default.register(require('refractor/lang/clike'));

_core.default.register(require('refractor/lang/javascript'));

_core.default.register(require('refractor/lang/typescript'));

_core.default.register(require('refractor/lang/markup'));

_core.default.register(require('refractor/lang/jsx'));

_core.default.register(require('refractor/lang/json'));

_core.default.register(require('refractor/lang/bash'));

_core.default.register(require('refractor/lang/swift'));

_core.default.register(require('refractor/lang/java'));

_core.default.register(require('refractor/lang/diff'));

function highlight(code, lang) {
  return _core.default.highlight(code, aliases[lang] || lang);
}
//# sourceMappingURL=highlight.js.map